module.exports = __webpack_public_path__ + "img/3MCircularTT-BoldItalic.a671bd5c.svg";